export const APPOINTMENT_TYPES = [
  { value: "clase_practica", label: "Cita clase práctica", short: "Práctica", icon: "Car", consumesBono: true },
  { value: "clase_teorica", label: "Cita clase teórica", short: "Teórica", icon: "BookOpen", consumesBono: false },
  { value: "examen_teorico", label: "Cita examen teórico", short: "Examen teórico", icon: "FileCheck", consumesBono: false },
  { value: "examen_practico", label: "Cita examen práctico", short: "Examen práctico", icon: "Trophy", consumesBono: false },
];

export const APPOINTMENT_TYPE_LABEL = APPOINTMENT_TYPES.reduce(
  (acc, t) => ({ ...acc, [t.value]: t.label }),
  {}
);

export const APPOINTMENT_TYPE_SHORT = APPOINTMENT_TYPES.reduce(
  (acc, t) => ({ ...acc, [t.value]: t.short }),
  {}
);

export function typeConsumesBono(type) {
  const t = APPOINTMENT_TYPES.find((x) => x.value === type);
  return !!(t && t.consumesBono);
}
